import catalog from './catalog'
import contacts from './contacts'
import thirdParty from './thirdParty'
import agreement from './agreement'
import users from './users'

export default {
  catalog,
  contacts,
  thirdParty,
  agreement,
  users,
  no_results: 'No results.',
  more: 'Show more'
}
